export const removePlusFromMsisdn = (text: string): string => {
  return text?.replace('+', '');
};

export const removeNonAlphaNumeric = (text: string): string => {
  return text.replace(/[^0-9a-z]/gi, '');
};

export function stripWhitespace(text?: string): string | undefined {
  return text ? text.replace(/ /g, '') : text;
}

export function getWordCase(word?: string): string | undefined {
  return word ? word.charAt(0).toUpperCase() + word.slice(1) : word;
}
